import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ToastService } from '@examdojo/core/toast';
import { ReviewPermissionsService } from '@examdojo/review';
import { UserQuery } from '@examdojo/user';
import { first, map, of } from 'rxjs';

export const validationRolesGuard: CanActivateFn = () => {
  const reviewPermissionsService = inject(ReviewPermissionsService);
  const toastService = inject(ToastService);
  const userQuery = inject(UserQuery);

  // If user is admin, skip permissions loading
  if (userQuery.hasRoleOrHigher('ADMIN')) {
    return of(true);
  }

  // For non-admin users, fetch review permissions
  return reviewPermissionsService.fetchUserPermissions().pipe(
    first(),
    map((reviewPermissions) => {
      if (!reviewPermissions.length) {
        toastService.error(`You don't have any review permissions. Please contact us.`);
        return false;
      }

      return true;
    }),
  );
};
